import React, { useContext, useState } from 'react';
import { StoreContext } from '../context/StoreContext';
import axios from 'axios';
import { FaCircleExclamation } from "react-icons/fa6";
import { useNavigate } from 'react-router-dom';

function OfferBenefitCard({ amount, title, subtitle, termsConditions, offerId, discount }) {
  const { orderId, accessToken, userId, setOfferData,setShowCheckout,setPaymentBreakup} = useContext(StoreContext);
  const [showTerms, setShowTerms] = useState(false); // State to control terms visibility
  const [showConfirmation, setShowConfirmation] = useState(false); // State for confirmation prompt

  const handleKnowMoreClick = () => {
    setShowTerms((prev) => !prev); // Toggle the visibility of terms
  };

  const handleApplyClick = () => {
    setShowConfirmation(true); // Show confirmation prompt
  };

  const handleCancel = () => {
    setShowConfirmation(false); // Hide confirmation prompt on cancel
  };

  const handleApplyConfirm = async () => {
    try {
      const requestData = {
        type: "BENEFIT_ID",
        orderId: orderId,
        benefitId: offerId
      };

      const response = await axios.post(
        "/api/nexus/checkout/benefit/apply",
        requestData,
        {
          headers: {
            "auth-token": accessToken,
            "user-id": userId,
          },
        }
      );
      console.log("Applied offer", response.data);
      setOfferData(response.data);
      setPaymentBreakup(response.data.data.paymentBreakup);
      setShowConfirmation(false); // Hide the confirmation prompt after applying
      setShowCheckout(false)
    } catch (error) {
      console.log("Error in applying offer", error);
    }
  };
  console.log("amount goes in offer & benefit",discount/100)

  return (
    <div className='relative pt-2'>
      <div className='flex flex-col w-full bg-[#FFFFFF] hover:border-[#FBC02D] border-transparent transition-colors duration-300 border-2 rounded-2xl px-3'>
        <div className='flex'>
          <div
            className='w-[30%] flex flex-col justify-center items-center'
            style={{
              borderRight: '4px dotted #ccc',
              paddingRight: '10px',
            }}
          >
            <h1 className='text-3xl flex flex-col w-full items-center justify-center font-bold'>₹{discount/ 100}</h1>
          </div>
          <div className='w-[70%] flex flex-col px-3 gap-2'>
            <h3 className='text-2xl md:text-3xl font-bold'>{title}</h3>
            <p className='text-xl md:text-lg text-[#29BB89]'>{subtitle}</p>
            <div className='flex w-full justify-between'>
              <button className='text-base text-[#8F8F97]' onClick={handleKnowMoreClick}>
                {showTerms ? '-Less' : 'Know More'}
              </button>
              <button onClick={handleApplyClick} className='text-xl md:text-2xl font-semibold text-[#FBC02D]'>
                Apply Now
              </button>
            </div>
          </div>
        </div>

        {/* Conditionally render the terms and conditions */}
        {showTerms && (
          <div className='mt-2 text-gray-700'>
            <h4 className='font-semibold text-base md:text-lg'>Terms and Conditions:</h4>
            <ul className='list-disc ml-5 text-[#8F8F97] text-sm md:text-base'>
              {termsConditions.map((term, index) => (
                <li key={index}>{term}</li>
              ))}
            </ul>
          </div>
        )}
      </div>

      {/* Conditionally render the centered confirmation prompt */}
      {showConfirmation && (
        <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
          <div className='bg-white p-6 rounded-lg shadow-lg w-[90%] max-w-md text-center'>
            <span className='flex items-center justify-center'>
            < FaCircleExclamation className='text-6xl text-[#FBC02D]'/>
            </span>
            <p className="text-xl md:text-2xl font-semibold pt-4">Apply {title} coupon?</p>
            <div className='flex flex-col items-center justify-center gap-4 mt-6'>
              <button
                className='bg-[#FBC02D] text-white w-40 py-2 px-4 rounded-2xl'
                onClick={handleApplyConfirm}
              >
                Apply
              </button>
              <button
                className='text-[#8F8F97] w-32 py-2 px-4 rounded hover:bg-red-500 hover:text-white'
                onClick={handleCancel}
              >
                Cancel
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default OfferBenefitCard;
